<template>
  <div class="main">
    <report-top
      ><template slot="search">
        <ly-search v-model="searchItem.keyWork" @search="search"></ly-search>
      </template>
    </report-top>
    <div id="formTable">
      <div class="formTableItem">
        <p class="label">时间范围</p>
        <start-end ref="startEnd" timeModel="2,3,0"></start-end>
      </div>

      <div class="formTableItem">
        <p class="label">项目名称</p>
        <div style="width: 120px">
          <selectItems
            :name="searchItem.groupName"
            @update:name="searchItem.groupName = $event"
            :id="searchItem.groupId"
            @update:id="searchItem.groupId = $event"
            clearable
          ></selectItems>
        </div>
      </div>

      <div class="formTableItem">
        <p class="label">所属部门</p>
        <selectGroup
          :name="searchItem.deptName"
          @update:name="searchItem.deptName = $event"
          :id="searchItem.deptId"
          @update:id="searchItem.deptId = $event"
          clearable
        >
        </selectGroup>
      </div>
      <div class="formTableItem">
        <p class="label">业务类型</p>
        <Select
          v-model="searchItem.businessType"
          clearable
          style="width: 120px"
          @on-clear="searchItem.businessType = ''"
        >
          <Option
            v-for="(x, index) in $t('businessType')"
            :value="x"
            :key="index"
            >{{ x }}</Option
          >
        </Select>
      </div>
      <div class="formTableItem">
        <p class="label">网格名称</p>
        <div style="width: 120px">
          <selectGrid
            :name="searchItem.gridName"
            @update:name="searchItem.gridName = $event"
            :id="searchItem.gridId"
            @update:id="searchItem.gridId = $event"
            clearable
          ></selectGrid>
        </div>
      </div>
      <div class="formTableItem">
        <Button @click="chaxun" type="primary" size="small" class="chaxun"
          >立即查询</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="signOn">
        {{ utils.time(row.signOn, "yymmddhhmm") }}
        <a @click="seePoint(row.signOnXy)">签到位置</a></template
      >
      <template slot-scope="{ row, index }" slot="signOff">
        {{ utils.time(row.signOff, "yymmddhhmm")
        }}<a @click="seePoint(row.signOffXy)">签退位置</a>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <ly-map ref="lymap"></ly-map>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openForm: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "姓名",
          key: "userName",
          minWidth: 80,
          maxWidth: 120,
        },
        {
          title: "项目名称",
          key: "groupName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "所属部门",
          key: "deptName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "业务类型",
          key: "businessType",
          minWidth: 80,
          maxWidth: 120,
        },
        {
          title: "状态",
          key: "statusLable",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "排班名称",
          key: "className",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "作业日期",
          key: "jobDate",
          minWidth: 100,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.jobDate, "yymmdd"));
          },
        },
        {
          title: "签到打卡",
          slot: "signOn",
          minWidth: 200,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.signOn, "yymmddhhmm"));
          },
        },
        {
          title: "是否区域外签到",
          key: "signOnOutside",
          minWidth: 80,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("sign." + data.row.signOnOutside));
          },
        },
        {
          title: "签退打卡",
          slot: "signOff",
          minWidth: 200,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.utils.time(data.row.signOff, "yymmddhhmm"));
          },
        },
        {
          title: "是否区域外签退",
          key: "signOffOutside",
          minWidth: 80,
          maxWidth: 200,
          render: (h, data) => {
            return h("div", this.$t("sign." + data.row.signOffOutside));
          },
        },
        {
          title: "排班时间",
          key: "classTime",
          minWidth: 80,
          maxWidth: 200,
        },
        {
          title: "网格名称",
          key: "gridName",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "备注信息",
          key: "remark",
          minWidth: 80,
          maxWidth: 200,
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        classesId: "",
        keyWork: "",
        businessType: "",
        groupName: "",
        groupId: "",
        deptName: "",
        deptId: "",
        gridName: "",
        gridId: "",
        endDate: "",
        startDate: "",
        pageNumber: "",
        pageNumber: 1,
        pageSize: 50,
      },
    };
  },
  methods: {
    seePoint(v) {
      var obj = {
        address: "",
        lng: v.x,
        lat: v.y,
      };
      this.$refs.lymap.open(obj);
    },
    getList() {
      console.log(this.searchItem);
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/scheduleHistory/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.tableData = data;
      });
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startDate = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endDate = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.reset();
      this.getList();
    },
    reset() {},
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/person/zycx.vue